<div class="csv-loader">
  <input
    #csvInput
    type="file"
    accept=".csv"
    hidden
    (change)="onFileSelected($event)"
  />

  <div class="csv-loader-actions">
    <button
      pButton
      type="button"
      class="p-button-sm"
      (click)="csvInput.click()"
      [disabled]="loading"
      [label]="'Cargar CSV'"
    ></button>
    <button
      pButton
      type="button"
      class="p-button-sm p-button-secondary"
      (click)="onClear()"
      [disabled]="loading"
      [label]="'Limpiar'"
    ></button>
    <span *ngIf="stateLabel" class="csv-state">{{ stateLabel }}</span>
    <span *ngIf="reportContent" class="report-ready">Informe listo</span>
    <button
      *ngIf="reportContent"
      pButton
      type="button"
      class="p-button-sm p-button-secondary"
      (click)="openReport()"
      [label]="'Ver informe'"
    ></button>
    <button
      *ngIf="reportContent"
      pButton
      type="button"
      class="p-button-sm p-button-secondary"
      (click)="downloadReport()"
      [label]="'Descargar informe'"
    ></button>
    <i *ngIf="loading" class="pi pi-spinner pi-spin"></i>
  </div>
</div>

<p-dialog
  header="Informe CSV"
  [(visible)]="reportDialogVisible"
  [modal]="true"
  [style]="{ width: '70vw' }"
  [draggable]="false"
  [resizable]="false"
>
  <pre class="report-content">{{ reportContent }}</pre>
</p-dialog>
